import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import type { KnowledgeBase } from "@/types/knowledgeBase";
import { ArrowLeft, PlusCircle } from "lucide-react";

interface KnowledgeBaseHeaderProps {
  knowledgeBase: KnowledgeBase;
  questionsCount: number;
  onBack: () => void;
  onAddQuestion: () => void;
}

export default function KnowledgeBaseHeader({
  knowledgeBase,
  questionsCount,
  onBack,
  onAddQuestion,
}: KnowledgeBaseHeaderProps) {
  return (
    <>
      <div className="flex items-center mb-6">
        <Button variant="ghost" size="icon" className="mr-2" onClick={onBack}>
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <div>
          <h1 className="text-2xl font-bold">
            Perguntas da Base de Conhecimento
          </h1>
          <p className="text-muted-foreground">{knowledgeBase.name}</p>
        </div>
      </div>

      <div className="flex justify-between mb-6">
        <div className="flex items-center gap-2">
          <Badge variant={knowledgeBase.isActive ? "default" : "secondary"}>
            {knowledgeBase.isActive ? "Ativo" : "Inativo"}
          </Badge>
          <span className="text-sm text-muted-foreground">
            {questionsCount} {questionsCount === 1 ? "pergunta" : "perguntas"}
          </span>
        </div>

        <Button className="gap-2" onClick={onAddQuestion}>
          <PlusCircle className="h-4 w-4" />
          Nova Pergunta
        </Button>
      </div>
    </>
  );
}
